import { AppRouteKey, RouteInfo } from './route_types';

// Define all routes with their propertie
export const AppRoutes: Record<AppRouteKey, RouteInfo> = {
  [AppRouteKey.LOGIN]: {
    key: AppRouteKey.LOGIN,
    path: '/login',
    name: 'Login',
    filePath: 'features/auth/presentation/pages/login_page.tsx',
  },
  [AppRouteKey.SIGNUP]: {
    key: AppRouteKey.SIGNUP,
    path: '/signup',
    name: 'Signup',
    filePath: 'features/auth/presentation/pages/signup_page.tsx',
  },
  [AppRouteKey.VERIFY_EMAIL]: {
    key: AppRouteKey.VERIFY_EMAIL,
    path: '/verify-email',
    name: 'Verify email',
    filePath: 'features/auth/presentation/pages/verify_email_page.tsx',
  },
  [AppRouteKey.VERIFY_INVITE]: {
    key: AppRouteKey.VERIFY_INVITE,
    path: '/verify-invite',
    name: 'Verify invite',
    filePath: 'features/auth/presentation/pages/verify_invite_page.tsx',
  },
  [AppRouteKey.SETUP_ORGANIZATION]: {
    key: AppRouteKey.SETUP_ORGANIZATION,
    path: '/create-organization',
    name: 'Create Organization',
    filePath: 'features/organization_setup/presentation/pages/organization_setup_page.tsx',
  },
  [AppRouteKey.HOME]: {
    key: AppRouteKey.HOME,
    path: '/home',
    name: 'Home',
    nameKey: 'home',
    filePath: 'routes/home._index.tsx',
  },
  [AppRouteKey.USER_MANAGEMENT]: {
    key: AppRouteKey.USER_MANAGEMENT,
    path: '/user-management',
    name: 'User Management',
    nameKey: 'userManagement',
    filePath: 'features/user_management/presentation/pages/user_management_page.tsx',
  },
  [AppRouteKey.SUPPORT]: {
    key: AppRouteKey.SUPPORT,
    path: '/support',
    name: 'Support',
    nameKey: 'support',
    filePath: 'routes/support.tsx',
  },
  [AppRouteKey.TERMS_CONDITIONS]: {
    key: AppRouteKey.TERMS_CONDITIONS,
    path: '/terms-conditions',
    name: 'Terms Conditions',
    nameKey: 'termsConditions',
    filePath: 'routes/terms-conditions.tsx',
  },
  [AppRouteKey.PRIVACY_POLICY]: {
    key: AppRouteKey.PRIVACY_POLICY,
    path: '/privacy-policy',
    name: 'Privacy Policy',
    nameKey: 'privacyPolicy',
    filePath: 'routes/privacy-policy.tsx',
  },
  [AppRouteKey.NOTIFICATIONS]: {
    key: AppRouteKey.NOTIFICATIONS,
    path: '/notifications',
    name: 'Notifications',
    nameKey: 'notifications',
    filePath: 'routes/notifications.tsx',
  },
  [AppRouteKey.NO_ACCESS]: {
    key: AppRouteKey.NO_ACCESS,
    path: '/no-access',
    name: 'No Access',
    nameKey: 'noAccess',
    filePath: 'routes/no-access.tsx',
  },

  [AppRouteKey.ACTIVE_UNDER_PLANNING]: {
    key: AppRouteKey.ACTIVE_UNDER_PLANNING,
    path: '/active/under-planning',
    name: 'Active Under Planning',
    nameKey: 'activeUnderPlanning',
    filePath: 'routes/active.under-planning.tsx',
  },
  [AppRouteKey.ACTIVE_PUBLISHED]: {
    key: AppRouteKey.ACTIVE_PUBLISHED,
    path: '/active/published',
    name: 'Active Published',
    nameKey: 'activePublished',
    filePath: 'routes/active.published.tsx',
  },
  [AppRouteKey.ROLES_MANAGEMENT]: {
    key: AppRouteKey.ROLES_MANAGEMENT,
    path: '/roles-management',
    name: 'Roles Management',
    nameKey: 'rolesManagement',
    filePath: 'features/roles_management/presentation/pages/roles_management_page.tsx',
  },
  [AppRouteKey.ORGANIZATION_SETTINGS]: {
    key: AppRouteKey.ORGANIZATION_SETTINGS,
    path: '/organization-settings',
    name: 'Organization Settings',
    nameKey: 'organizationSettings',
    filePath: 'features/organization_settings/presentation/pages/organization_settings_page.tsx',
  },
  [AppRouteKey.ORGANIZATION_PROFILE_SETTINGS]: {
    key: AppRouteKey.ORGANIZATION_PROFILE_SETTINGS,
    path: '/organization-profile-settings',
    name: 'Organization Profile Settings',
    nameKey: 'profileSettings',
    filePath:
      'features/organization_settings/presentation/pages/organization_profile_settings_page.tsx',
  },
  [AppRouteKey.AUDIT_SETTINGS]: {
    key: AppRouteKey.AUDIT_SETTINGS,
    path: '/audit/settings',
    name: 'Audit Settings',
    nameKey: 'auditSettings',
    filePath: 'features/auditor_app/presentation/pages/AuditorSettings.tsx',
  },
  [AppRouteKey.AUDIT_PROFILE]: {
    key: AppRouteKey.AUDIT_PROFILE,
    path: '/audit/profile',
    name: 'Audit Profile',
    nameKey: 'auditProfile',
    filePath: 'features/auditor_app/presentation/pages/AuditFarmerProfile.tsx',
  },
  [AppRouteKey.AUDIT_FARMER]: {
    key: AppRouteKey.AUDIT_FARMER,
    path: '/audit/farmer/',
    name: 'Audit Farmer',
    nameKey: 'auditFarmer',
    filePath: 'features/auditor_app/presentation/pages/DiscoverFarmer.tsx',
    children: ['AUDIT_FARMER_DETAIL'],
  },
  [AppRouteKey.AUDIT_FARMER_DETAIL]: {
    key: AppRouteKey.AUDIT_FARMER_DETAIL,
    path: '/audit/farmerdetails/',
    name: 'Audit Farmer Detail',
    nameKey: 'auditFarmerDetail',
    filePath: 'features/auditor_app/presentation/pages/Farmer.tsx',
    parent: 'AUDIT_FARMER',
  },

  [AppRouteKey.PRODUCTION_HEAD_SEASON]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON,
    path: '/production-season',
    name: 'Seasons',
    nameKey: 'seasons',
    filePath: 'features/production_head/presentation/pages/productionHeadSeason.tsx',
    children: ['PRODUCTION_HEAD_SEASON_DETAIL'],
  },
  [AppRouteKey.PRODUCTION_HEAD_SEASON_CREATE]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_CREATE,
    path: '/production-season/create',
    name: 'Production Season Create',
    nameKey: 'createSeason',
    filePath: 'features/production_head/presentation/pages/createSeason.tsx',
  },
  [AppRouteKey.PRODUCTION_HEAD_SEASON_EDIT]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_EDIT,
    path: '/production-season/edit/:seasonId',
    name: 'Edit Season',
    nameKey: 'editSeason',
    filePath: 'features/production_head/presentation/pages/editSeason.tsx',
  },
  [AppRouteKey.PRODUCTION_HEAD_SEASON_SETTINGS]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_SETTINGS,
    path: '/season-settings',
    name: 'Season Settings',
    nameKey: 'seasonSettings',
    filePath: 'features/production_head/presentation/pages/productionHeadSeasonSetting.tsx',
    children: [
      'PRODUCTION_HEAD_SEASON_SETTINGS_VERSION_DETAILS',
      'PRODUCTION_HEAD_SEASON_PLAN_VERSION_REVISION',
    ],
  },
  [AppRouteKey.PRODUCTION_HEAD_SEASON_SETTINGS_VERSION_DETAILS]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_SETTINGS_VERSION_DETAILS,
    path: '/season-settings/:seasonVersionId',
    name: 'Season Version Details',
    nameKey: 'seasonVersionDetails',
    filePath: 'routes/production_head_routes/season-settings.$seasonId._index.tsx',
    parent: 'PRODUCTION_HEAD_SEASON_SETTINGS',
  },
  [AppRouteKey.PRODUCTION_HEAD_SEASON_DETAIL]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_DETAIL,
    path: '/season-details',
    name: 'Season Detail',
    nameKey: 'seasonDetail',
    filePath: 'routes/production_head_routes/season-details.$seasonId._index.tsx',
    parent: 'PRODUCTION_HEAD_SEASON',
  },

  [AppRouteKey.PRODUCTION_HEAD_DISTRIBUTE_TARGETS]: {
    key: AppRouteKey.PRODUCTION_HEAD_DISTRIBUTE_TARGETS,
    path: '/distribute-targets',
    name: 'Distribute Targets',
    nameKey: 'distributeTargets',
    filePath: 'features/production_head/presentation/pages/distributeTargets.tsx',
    parent: 'PRODUCTION_HEAD_SEASON',
  },

  [AppRouteKey.PRODUCTION_HEAD_SEASON_PLAN_VERSION_REVISION]: {
    key: AppRouteKey.PRODUCTION_HEAD_SEASON_PLAN_VERSION_REVISION,
    path: '/season-settings/:seasonId/:planId/:versionId/:revisionId',
    name: 'Season Plan Version Revision',
    nameKey: 'seasonPlanVersionRevision',
    filePath:
      'routes/production_head_routes/season.$seasonId.plan.$planId.version.$versionId.revision.$revisionId.tsx',
    parent: 'PRODUCTION_HEAD_SEASON_SETTINGS',
  },

  [AppRouteKey.PRODUCTION_HEAD_OPERATIONAL_PLAN_VERSION_DETAIL]: {
    key: AppRouteKey.PRODUCTION_HEAD_OPERATIONAL_PLAN_VERSION_DETAIL,
    path: '/season-settings/operational/:operationalPlanVersionId',
    name: 'Operational Plan Version Detail',
    nameKey: 'version',
    filePath:
      'routes/production_head_routes/season-settings.operational.$seasonId.$operationalPlanId.$operationalPlanVersionId.tsx',
    parent: 'PRODUCTION_HEAD_SEASON_SETTINGS',
    getName: ({ loaderData }) => {
      return loaderData?.versionName || '';
    },
  },

  [AppRouteKey.PRODUCTION_HEAD_HARVEST_PLAN]: {
    key: AppRouteKey.PRODUCTION_HEAD_HARVEST_PLAN,
    path: '/season-settings/harvest/:harvestPlanVersionId',
    name: 'Harvest & Recovery Plan',
    nameKey: 'version',
    filePath:
      'routes/production_head_routes/season-settings.harvest.$seasonId.$harvestPlanId.$harvestPlanVersionId.tsx',
    parent: 'PRODUCTION_HEAD_SEASON_SETTINGS',
  },

  [AppRouteKey.AGRONOMIST_SEASONS]: {
    key: AppRouteKey.AGRONOMIST_SEASONS,
    path: '/agronomist-season',
    name: 'Seasons',
    nameKey: 'seasons',
    filePath: 'features/agronomist/presentation/pages/agronomist_seasons.tsx',
  },

  [AppRouteKey.AGRONOMIST_SEASON_PLAN]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN,
    path: '/agronomist-season-plan',
    name: 'Season',
    nameKey: 'season',
    filePath: 'routes/agronomist_routes/agronomist-season-plan._index.tsx',
    // Add children property to indicate nested routes
    children: [
      'AGRONOMIST_SEASON_PLAN_CREATE',
      'AGRONOMIST_SEASON_PLAN_SEASON',
      'AGRONOMIST_SEASON_PLAN_SEASON_PLAN',
      'AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION',
      'AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION_REVISION',
    ],
  },
  [AppRouteKey.AGRONOMIST_SEASON_PLAN_CREATE]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN_CREATE,
    path: '/agronomist-season-plan/create-plan',
    name: 'Create Season Plan',
    nameKey: 'createSeasonPlan',
    filePath: 'routes/agronomist_routes/agronomist-season-plan.create-plan.tsx',
    parent: 'AGRONOMIST_SEASON_PLAN',
  },
  // Season-specific route
  [AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON,
    path: '/agronomist-season-plan/:seasonId',
    name: 'Season Plan',
    nameKey: 'seasonPlan',
    filePath: 'routes/agronomist_routes/agronomist-season-plan.$seasonId._index.tsx',
    parent: 'AGRONOMIST_SEASON_PLAN',
  },

  // Plan-specific route
  [AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN,
    path: '/agronomist-season-plan/:seasonId/:planId',
    name: 'Season Plan Version',
    nameKey: 'seasonPlanVersion',
    filePath: 'routes/agronomist_routes/agronomist-season-plan.$seasonId.$planId._index.tsx',
    parent: 'AGRONOMIST_SEASON_PLAN',
  },

  // Version-specific route
  [AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION,
    path: '/agronomist-season-plan/:seasonId/:planId/:versionId',
    name: 'Season Plan Version Upload',
    nameKey: 'seasonPlanVersionUpload',
    filePath: 'routes/agronomist_routes/agronomist-season-plan.$seasonId.$planId.$versionId.tsx',
    parent: 'AGRONOMIST_SEASON_PLAN',
  },

  // Revision-specific route
  [AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION_REVISION]: {
    key: AppRouteKey.AGRONOMIST_SEASON_PLAN_SEASON_PLAN_VERSION_REVISION,
    path: '/agronomist-season-plan/:seasonId/:planId/:versionId/revision',
    name: 'Season Plan Version Revision',
    nameKey: 'seasonPlanVersionRevision',
    filePath:
      'routes/agronomist_routes/agronomist-season-plan.$seasonId.$planId.$versionId.revision.$revisionId.tsx',
    parent: 'AGRONOMIST_SEASON_PLAN',
  },

  // Operational Plan routes
  [AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_INDEX]: {
    key: AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_INDEX,
    path: '/agronomist-operational-plan',
    name: 'Operational Plan',
    nameKey: 'operation',
    filePath: 'routes/agronomist_routes/agronomist-operational-plan._index.tsx',
  },

  [AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_LIST]: {
    key: AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_LIST,
    path: '/agronomist-operational-plan/:seasonId',
    name: 'Operational Plan List',
    nameKey: 'operationalPlan',
    filePath: 'routes/agronomist_routes/agronomist-operational-plan.$seasonId._index.tsx',
    // parent: 'AGRONOMIST_OPERATIONAL_PLAN_INDEX',
    // children: ['AGRONOMIST_OPERATIONAL_PLAN'],
  },

  [AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN]: {
    key: AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN,
    path: '/agronomist-operational-plan/:seasonId/:operationalPlanId',
    name: 'Operational Plan Versions',
    nameKey: 'operationalPlanVersion',
    filePath:
      'routes/agronomist_routes/agronomist-operational-plan.$seasonId.$operationalPlanId._index.tsx',
    // parent: 'AGRONOMIST_OPERATIONAL_PLAN_LIST',
    // children: ['AGRONOMIST_OPERATIONAL_PLAN_VERSION'],
  },

  [AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_VERSION]: {
    key: AppRouteKey.AGRONOMIST_OPERATIONAL_PLAN_VERSION,
    path: '/agronomist-operational-plan/:seasonId/:operationalPlanId/:operationalPlanVersionId',
    name: 'Operational Plan Version',
    nameKey: 'operationalPlanVersionUpload',
    filePath:
      'routes/agronomist_routes/agronomist-operational-plan.$seasonId.$operationalPlanId.$operationalPlanVersionId.tsx',
    // parent: 'AGRONOMIST_OPERATIONAL_PLAN',
  },

  [AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_INDEX]: {
    key: AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_INDEX,
    path: '/agronomist-harvest-recovery',
    name: 'Harvest & Recovery',
    nameKey: 'harvestRecovery',
    filePath: 'routes/agronomist_routes/agronomist-harvest-recovery._index.tsx',
  },

  [AppRouteKey.AGRONOMIST_HARVEST_RECOVERY]: {
    key: AppRouteKey.AGRONOMIST_HARVEST_RECOVERY,
    path: '/agronomist-harvest-recovery/:seasonId/:harvestPlanId',
    name: 'Harvest & Recovery Versions',
    nameKey: 'harvestRecoveryVersion',
    filePath:
      'routes/agronomist_routes/agronomist-harvest-recovery.$seasonId.$harvestPlanId._index.tsx',
    parent: AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_INDEX,
  },

  [AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_VERSION]: {
    key: AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_VERSION,
    path: '/agronomist-harvest-recovery/:seasonId/:harvestPlanId/:harvestPlanVersionId',
    name: 'Harvest & Recovery Version',
    nameKey: 'harvestRecoveryVersionUpload',
    filePath:
      'routes/agronomist_routes/agronomist-harvest-recovery.$seasonId.$harvestPlanId.$harvestPlanVersionId.tsx',
    parent: AppRouteKey.AGRONOMIST_HARVEST_RECOVERY_INDEX,
  },

  [AppRouteKey.FARMER_REPORT]: {
    key: AppRouteKey.FARMER_REPORT,
    path: '/farmer-report',
    name: 'Farmer Report',
    nameKey: 'farmerReport',
    filePath: 'routes/farmer_report_routes/farmer-report._index.tsx',
    children: [
      AppRouteKey.FARMER_REPORT_DIVISION_REPORT,
      AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT,
      AppRouteKey.FARMER_REPORT_VILLAGE_REPORT,
      AppRouteKey.FARMER_REPORT_CLUB_REPORT,
      AppRouteKey.FARMER_REPORT_PLOTS,
    ],
    staticLabel: 'farmerReportTitle',
  },
  [AppRouteKey.FARMER_REPORT_REGION_MANAGER]: {
    key: AppRouteKey.FARMER_REPORT_REGION_MANAGER,
    path: '/farmer-report/region-manager',
    name: 'Region Manager',
    filePath: 'routes/farmer_report_routes/farmer-report-rm.tsx',
    parent: AppRouteKey.FARMER_REPORT,
    feature: 'farmerReport',
  },

  [AppRouteKey.FARMER_REPORT_DIVISION_REPORT]: {
    key: AppRouteKey.FARMER_REPORT_DIVISION_REPORT,
    path: '/farmer-report/division-report/:divisionId/',
    name: 'Municipality List', // fallback if getName is not used
    filePath: 'routes/farmer_report_routes/farmer-report.division.$divisionId._index.tsx',
    parent: AppRouteKey.FARMER_REPORT,
    feature: 'farmerReport',
    getName: ({ params, loaderData }) => {
      const name = loaderData?.divisionName || 'Division';
      // const id = params?.divisionId ?? '';
      // return `${name} - ${id}`;
      return `${name}`;
    },
    staticLabel: 'division',
    children: [
      AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT,
      AppRouteKey.FARMER_REPORT_VILLAGE_REPORT,
      AppRouteKey.FARMER_REPORT_CLUB_REPORT,
      AppRouteKey.FARMER_REPORT_PLOTS,
    ],
  },

  [AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT]: {
    key: AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT,
    path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId',
    name: 'Village List',
    filePath: 'routes/farmer_report_routes/farmer-report.municipality.$municipalityId._index.tsx',
    parent: AppRouteKey.FARMER_REPORT_DIVISION_REPORT,
    feature: 'farmerReport',
    getName: ({ params, loaderData }) => {
      const name = loaderData?.municipalityName || 'Municipality';
      // const id = params?.municipalityId ?? '';
      return `${name}`;
    },
    staticLabel: 'municipality',
    children: [
      AppRouteKey.FARMER_REPORT_VILLAGE_REPORT,
      AppRouteKey.FARMER_REPORT_CLUB_REPORT,
      AppRouteKey.FARMER_REPORT_PLOTS,
    ],
  },

  [AppRouteKey.FARMER_REPORT_VILLAGE_REPORT]: {
    key: AppRouteKey.FARMER_REPORT_VILLAGE_REPORT,
    path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/village-report/:villageId',
    name: 'Club List',
    filePath: 'routes/farmer_report_routes/farmer-report.village.$villageId._index.tsx',
    parent: AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT,
    feature: 'farmerReport',
    getName: ({ params, loaderData }) => {
      const name = loaderData?.villageName || 'Village';
      // const id = params?.villageId ?? '';
      return `${name}`;
    },
    staticLabel: 'village',
    children: [AppRouteKey.FARMER_REPORT_CLUB_REPORT, AppRouteKey.FARMER_REPORT_PLOTS],
  },

  [AppRouteKey.FARMER_REPORT_ZONE_REPORT]: {
    key: AppRouteKey.FARMER_REPORT_ZONE_REPORT,
    path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/zone-report/:zoneId',
    name: 'Club List',
    filePath: 'routes/farmer_report_routes/farmer-report.zone.$zoneId._index.tsx',
    parent: AppRouteKey.FARMER_REPORT_MUNICIPALITY_REPORT,
    feature: 'farmerReport',
    getName: ({ params, loaderData }) => {
      const name = loaderData?.zoneName || 'Zone';
      // const id = params?.villageId ?? '';
      return `${name}`;
    },
    staticLabel: 'zone',
    children: [AppRouteKey.FARMER_REPORT_CLUB_REPORT, AppRouteKey.FARMER_REPORT_PLOTS],
  },

  [AppRouteKey.FARMER_REPORT_CLUB_REPORT]: {
    key: AppRouteKey.FARMER_REPORT_CLUB_REPORT,
    // path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/village-report/:villageId/club-report/:clubId',
    path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/zone-report/:zoneId/club-report/:clubId',
    name: 'Farmer List',
    filePath: 'routes/farmer_report_routes/farmer-report.club.$clubId._index.tsx',
    // parent: AppRouteKey.FARMER_REPORT_VILLAGE_REPORT,
    parent: AppRouteKey.FARMER_REPORT_ZONE_REPORT,
    feature: 'farmerReport',
    getName: ({ loaderData }) => {
      const name = loaderData?.clubName || 'Club';
      // const id = params?.clubId ?? '';
      return `${name}`;
    },
    staticLabel: 'club',
    children: [AppRouteKey.FARMER_REPORT_PLOTS],
  },

  [AppRouteKey.FARMER_REPORT_PLOTS]: {
    key: AppRouteKey.FARMER_REPORT_PLOTS,
    // path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/village-report/:villageId/club-report/:clubId/plots',
    path: '/farmer-report/division-report/:divisionId/municipality-report/:municipalityId/zone-report/:zoneId/club-report/:clubId/plots',
    name: '',
    filePath: 'routes/farmer_report_routes/farmer-report.plots.tsx',
    parent: AppRouteKey.FARMER_REPORT_CLUB_REPORT,
    feature: 'farmerReport',
    getName: ({ loaderData }) => {
      const name = loaderData?.farmerName || '';
      // const id = params?.clubId ?? '';
      return `${name}`;
    },
    staticLabel: 'plot',
  },

  [AppRouteKey.FARMER_REPORT_GLOBAL_MAP]: {
    key: AppRouteKey.FARMER_REPORT_GLOBAL_MAP,
    path: '/farmer-report-global-map',
    name: 'Plot Map',
    filePath: 'routes/farmer_report_routes/farmer-report.global-map.tsx',
    feature: 'farmerReport',
    staticLabel: 'globalPlotMap',
  },
  [AppRouteKey.FARMER_REPORT_FARMER_360]: {
    key: AppRouteKey.FARMER_REPORT_FARMER_360,
    path: '/farmer-report-farmer-360',
    name: 'Farmer 360',
    filePath: 'routes/farmer_report_routes/farmer-report.farmer-360.tsx',
    parent: AppRouteKey.FARMER_REPORT_GLOBAL_MAP,
    feature: 'farmerReport',
    staticLabel: 'farmer360Title',
  },

  [AppRouteKey.USER_REPORT_REGION_MANAGER]: {
    key: AppRouteKey.USER_REPORT_REGION_MANAGER,
    path: '/rm-user-report',
    name: 'User Report',
    filePath: 'routes/user_report_routes/rm-user-report._index.tsx',
    staticLabel: 'RegionalManagerUserReportTitle',
  },

  [AppRouteKey.USER_REPORT_BUSINESS_USER]: {
    key: AppRouteKey.USER_REPORT_BUSINESS_USER,
    path: '/bu-user-report',
    name: 'User Report',
    filePath: 'routes/user_report_routes/bu-user-report._index.tsx',
    staticLabel: 'BusinessUserReportTitle',
  },
  [AppRouteKey.SUPERVISOR_USER_REPORT_BUSINESS_USER]: {
    key: AppRouteKey.SUPERVISOR_USER_REPORT_BUSINESS_USER,
    path: '/bu-user-report/rm/:rmId',
    name: 'Supervisor Report',
    filePath: 'routes/user_report_routes/bu-user-report.rm.$rmId_index.tsx',
    staticLabel: 'BusinessUserReportTitle',
  },
  [AppRouteKey.FIELD_TECH_USER_REPORT_BUSINESS_USER]: {
    key: AppRouteKey.FIELD_TECH_USER_REPORT_BUSINESS_USER,
    path: '/bu-user-report/rm/:rmId/sv/:svId',
    name: 'Field Tech Report',
    filePath: 'routes/user_report_routes/bu-user-report.sv.$svId_index.tsx',
    staticLabel: 'BusinessUserReportTitle',
  },

  [AppRouteKey.SEASON_REPORT]: {
    key: AppRouteKey.SEASON_REPORT,
    path: '/season-report',
    name: 'Season Report',
    nameKey: 'Season Report',
    filePath: 'routes/season_report_routes/season-report._index.tsx',
    children: [AppRouteKey.SEASON_REPORT_DETAIL],
    staticLabel: '',
  },

  [AppRouteKey.SEASON_REPORT_DETAIL]: {
    key: AppRouteKey.SEASON_REPORT_DETAIL,
    path: '/season-report/:seasonId',
    name: 'Season Report Detail',
    nameKey: 'Season Report Detail',
    filePath: 'routes/season_report_routes/season-report._$seasonId.tsx',
    parent: AppRouteKey.SEASON_REPORT,
    staticLabel: '',
    getName: ({ loaderData }) => {
      const name = loaderData?.season?.seasonName || 'Season';
      return `${name}`;
    },
  },

  [AppRouteKey.PROFILE]: {
    key: AppRouteKey.PROFILE,
    path: '/profile',
    name: 'Profile',
    nameKey: 'profile',
    filePath: 'features/profile/presentation/pages/profile.tsx',
  },

  [AppRouteKey.CONTRACT_REPORT]: {
    key: AppRouteKey.CONTRACT_REPORT,
    path: '/contract-report',
    name: 'Contract Report',
    nameKey: 'contractReport',
    filePath: 'routes/contract_report_routes/contract-report._index.tsx',
    staticLabel: 'contractReportTitle',
    children: ['CONTRACT_REPORT_SEASON_DETAIL', 'CONTRACT_REPORT_REGIONAL_TARGET_DETAIL'],
  },

  [AppRouteKey.CONTRACT_REPORT_SEASON_DETAIL]: {
    key: AppRouteKey.CONTRACT_REPORT_SEASON_DETAIL,
    path: '/contract-report/season/:seasonId',
    name: 'Season Detail',
    nameKey: 'seasonDetail',
    filePath: 'routes/contract_report_routes/contract-report.season.$seasonId._index.tsx',
    parent: 'CONTRACT_REPORT',
    children: ['CONTRACT_REPORT_REGIONAL_TARGET_DETAIL'],
    getName: ({ loaderData }) => {
      const name = loaderData?.seasonName || 'Season';
      return `${name}`;
    },
  },

  [AppRouteKey.CONTRACT_REPORT_REGIONAL_TARGET_DETAIL]: {
    key: AppRouteKey.CONTRACT_REPORT_REGIONAL_TARGET_DETAIL,
    path: '/contract-report/season/:seasonId/regional-target/:regionalTargetId',
    name: 'Regional Target Detail',
    nameKey: 'regionalTargetDetail',
    filePath:
      'routes/contract_report_routes/contract-report.season.$seasonId.regional-target.$regionalTargetId._index.tsx',
    parent: 'CONTRACT_REPORT_SEASON_DETAIL',
    getName: ({ loaderData }) => {
      const name = loaderData?.contractMetrics?.[0]?.regionalTargetName || 'Regional Target';
      return `${name}`;
    },
  },

  [AppRouteKey.BUSINESS_ADMIN]: {
    key: AppRouteKey.BUSINESS_ADMIN,
    path: '/business-admin',
    name: 'Business Admin',
    nameKey: 'businessAdminOrganizationData',
    filePath: 'features/business_admin_list/presentation/pages/business_admin_settings_page.tsx',
  },

  [AppRouteKey.BUSINESS_ADMIN_REGIONS]: {
    key: AppRouteKey.BUSINESS_ADMIN_REGIONS,
    path: '/business-admin-regions',
    name: 'Regions',
    nameKey: 'businessAdminPlatformData',
    filePath: 'features/business_admin_list/presentation/pages/business_admin_regions_page.tsx',
  },

  [AppRouteKey.BUSINESS_ADMIN_METRICS]: {
    key: AppRouteKey.BUSINESS_ADMIN_METRICS,
    path: '/business-admin-metrics',
    name: 'Metrics',
    nameKey: 'businessAdminPlatformData',
    filePath: 'features/business_admin_list/presentation/pages/business_admin_metrics_page.tsx',
    parent: 'BUSINESS_ADMIN_REGIONS',
  },

  [AppRouteKey.BUSINESS_ADMIN_BILLING_ENTITY]: {
    key: AppRouteKey.BUSINESS_ADMIN_BILLING_ENTITY,
    path: '/business-admin-billing-entity',
    name: 'Billing Entity',
    nameKey: 'businessAdminOrganizationData',
    filePath:
      'features/business_admin_list/presentation/pages/business_admin_billing_entity_page.tsx',
    parent: 'BUSINESS_ADMIN',
  },

  [AppRouteKey.NOT_EXIST]: {
    key: AppRouteKey.NOT_EXIST,
    path: '*',
    name: 'Not Found',
    nameKey: 'notFound',
    filePath: 'routes/$.tsx',
  },
};
